import { Component, Input, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { OrderItem } from '../../order-v2.types';
import { AdjustmentsModalComponent } from '../adjustments-modal/adjustments-modal.component';

@Component({
  selector: 'app-order-v2-items',
  standalone: true,
  imports: [CommonModule, RouterLink, AdjustmentsModalComponent],
  templateUrl: './order-items.component.html',
  styleUrl: './order-items.component.scss',
})
export class OrderItemsComponent {
  @Input({ required: true }) items: OrderItem[] = [];

  readonly modalOpen = signal(false);
  readonly selectedItem = signal<OrderItem | null>(null);

  openAdjustments(item: OrderItem): void {
    this.selectedItem.set(item);
    this.modalOpen.set(true);
  }

  closeModal(): void {
    this.modalOpen.set(false);
  }

  formatCents(value: number): string {
    return ((value ?? 0) / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  }

  formatAdjustment(value: number): string {
    const formatted = this.formatCents(value);
    if ((value ?? 0) > 0) return `+${formatted}`;
    return formatted;
  }

  totalAdjustments(item: OrderItem): number {
    return (item.adjustments ?? []).reduce((sum, a) => sum + a.value, 0);
  }

  adjClass(value: number): string {
    if (value < 0) return 'val-neg';
    if (value > 0) return 'val-pos';
    return 'val-zero';
  }

  get adjustedCount(): number {
    return this.items.filter((i) => (i.adjustments?.length ?? 0) > 0).length;
  }
}
